import Vue from 'vue';
import Vuex from 'vuex';
import cloneDeep from 'lodash.clonedeep';
import api from '../api/';

Vue.use(Vuex);

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state: {
        defaultRegion: 'na',
        preventSearch: true,
        defaultOption: 'products',
        selectedTab: 'products',
        selectedCountry: '',
        selectedProduct: '',
        searchProductType: [],
        status: 'selected',
        apiStatus: 'wait',
        showWarning: false,
        listedResults: [],
        filteredExchangeResults: [],
        productResults: [],
        searchResults: [],
        orderTypesResults: [],
        products: [],
        typesList: [],
        selectedRegion: [],
        exchanges: [],
        selectedExchange: '',
        selectedExch: '',
        selectedProductType: '',
        newProducts: 'all',
        totalPages: '',
        pageNumber: 1,
        numShow: 'Show 100 Rows',
        resultStatus: true,
        types: [],
        hostName: window.location.hostname,
        filteredResults: [],
        userSelection: false,
        allowedCryptoProducts: ["BTC", "ETH", "BCH", "LTC"],
        secDefData: [],
        previousSort: { type: 'symbol', dir: 'asc' },
        currentSort: { type: 'symbol', dir: 'asc' },
        searchTerm: '',
        useSearchTerm: false,
        i158Restrictions: [],
        apitestResponse: [
            {"conid":"265598","companyHeader":"APPLE INC","companyName":null,"symbol":"AAPL","description":"NASDAQ","restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"STK","conid":"265598"},{"secType":"OPT"},{"secType":"WAR"},{"secType":"CFD"},{"secType":"IOPT"},{"secType":"BAG"}]},
            {"conid":"194322803","companyHeader":"APPLE HOSPITALITY REIT INC","companyName":null,"symbol":"APLE","description":"NYSE","restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"STK","conid":"194322803"},{"secType":"OPT"},{"secType":"CFD"},{"secType":"BAG"}]},
            {"conid":"197339932","companyHeader":"APPLEGREEN PLC","companyName":null,"symbol":"APGN","description":"VALUE","restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"STK","conid":"197339932"}]},
            {"conid":"47416860","companyHeader":"APPLE INTERNATIONAL CO LTD","companyName":null,"symbol":"2788","description":"TSEJ","restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"STK","conid":"47416860"}]},
            {"conid":"290651239","companyHeader":"LEVERAGE SHARES 2X APPLE","companyName":null,"symbol":"AAP2","description":"LSEETF","restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"STK","conid":"290651239"}]},
            {"conid":"363412573","companyHeader":"LEVERAGE SHARES 2X APPLE","companyName":null,"symbol":"AAPE","description":"LSEETF","restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"STK","conid":"363412573"}]},
            {"conid":"304021411","companyHeader":"LEVERAGE SHARES 2X APPLE","companyName":null,"symbol":"2AAP","description":"LSEETF","restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"STK","conid":"304021411"}]},
            {"conid":"603849326","companyHeader":"APPLE YLD SHARES PURPOSE","companyName":null,"symbol":"APLY","description":"AEQLIT","restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"STK","conid":"603849326"}]},
            {"conid":"425172073","companyHeader":"LEVERAGE SHARES 3X APPLE","companyName":null,"symbol":"AAP3","description":"LSEETF","restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"STK","conid":"425172073"}]},
            {"conid":"425172082","companyHeader":"LEVERAGE SHARES 3X APPLE","companyName":null,"symbol":"3APE","description":"LSEETF","restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"STK","conid":"425172082"}]},
            {"conid":"425172076","companyHeader":"LEVERAGE SHARES 3X APPLE","companyName":null,"symbol":"3AAP","description":"LSEETF","restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"STK","conid":"425172076"}]},
            {"conid":"430747381","companyHeader":"GRANITESHARES 3X SHORT APPLE","companyName":null,"symbol":"3SAP","description":"LSEETF","restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"STK","conid":"430747381"}]},
            {"conid":"482858971","companyHeader":"GRANITESHARES 3X SHORT APPLE","companyName":null,"symbol":"3SAE","description":"LSEETF","restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"STK","conid":"482858971"}]},
            {"conid":"482858964","companyHeader":"GRANITESHARES 3X SHORT APPLE","companyName":null,"symbol":"3SWP","description":"LSEETF","restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"STK","conid":"482858964"}]},
            {"conid":"430747346","companyHeader":"GRANITESHARES 3X LONG APPLE","companyName":null,"symbol":"3LAP","description":"LSEETF","restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"STK","conid":"430747346"}]},
            {"issuers":[{"id":"e1432232","name":"Apple Inc"}],"bondid":15,"conid":"-1","companyHeader":"Apple Inc","companyName":null,"symbol":null,"description":null,"restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"BOND"}]},
            {"issuers":[{"id":"e1634713","name":"Apple Bank for Savings"}],"bondid":16,"conid":"-1","companyHeader":"Apple Bank for Savings","companyName":null,"symbol":null,"description":null,"restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"BOND"}]},
            {"issuers":[{"id":"e1634714","name":"Apple Financial Holdings Inc"}],"bondid":17,"conid":"-1","companyHeader":"Apple Financial Holdings Inc","companyName":null,"symbol":null,"description":null,"restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"BOND"}]},
            {"issuers":[{"id":"e1360703","name":"Appleton Papers Inc"}],"bondid":18,"conid":"-1","companyHeader":"Appleton Papers Inc","companyName":null,"symbol":null,"description":null,"restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"BOND"}]},
            {"issuers":[{"id":"e3285945","name":"Farmers & Merchants State Bank of Appleton"}],"bondid":19,"conid":"-1","companyHeader":"Farmers & Merchants State Bank of Appleton","companyName":null,"symbol":null,"description":null,"restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"BOND"}]},
            {"issuers":[{"id":"e3348330","name":"Appletree Securities DAC"}],"bondid":20,"conid":"-1","companyHeader":"Appletree Securities DAC","companyName":null,"symbol":null,"description":null,"restricted":null,"fop":null,"opt":null,"war":null,"sections":[{"secType":"BOND"}]}
        ],
        marketdata: '',
        services: [
            { name: "products", selected: false },
            { name: "exchanges", selected: false },
        ],
        regions: [
            { name: 'canada', selected: false, region: "na" , value: "CA"},
            { name: 'mexico', selected: false, region: "na", value: "MX"},
            { name: 'united_states', selected: false, region: "na", value: "US"},
            { name: 'brazil', selected: false, region: "sa" , value: "BR"},
            { name: 'austria', selected: false, region: "eu" , value: "AT"},
            { name: 'belgium', selected: false, region: "eu" , value: "BE"},
            // { name: 'Bulgaria', selected: false, region: "eu" , value: "BG"},
            // { name: 'Croatia', selected: false, region: "eu" , value: "HR"},
            { name: 'czech_republic', selected: false, region: "eu" , value: "CZ"},
            { name: 'denmark', selected: false, region: "eu" , value: "DK"},
            { name: 'estonia', selected: false, region: "eu" , value: "EE"},
            // { name: 'Finland', selected: false, region: "eu" , value: "FI"},
            { name: 'france', selected: false, region: "eu" , value: "FR"},
            { name: 'germany', selected: false, region: "eu" , value: "DE"},
            { name: 'hungary', selected: false, region: "eu" , value: "HU"},
            // { name: 'Ireland', selected: false, region: "eu" , value: "IE"},
            { name: 'israel', selected: false, region: "eu" , value: "IL"},
            { name: 'italy', selected: false, region: "eu" , value: "IT"},
            { name: 'latvia', selected: false, region: "eu" , value: "LV"},
            { name: 'lithuania', selected: false, region: "eu" , value: "LT"},
            // { name: 'Luxembourg', selected: false, region: "eu" , value: "LU"},
            { name: 'netherlands', selected: false, region: "eu" , value: "NL"},
            { name: 'norway', selected: false, region: "eu" , value: "NO"},
            { name: 'poland', selected: false, region: "eu" , value: "PL"},
            { name: 'portugal', selected: false, region: "eu" , value: "PT"},
            // { name: 'Romania', selected: false, region: "eu" , value: "RO"},
            { name: 'spain', selected: false, region: "eu" , value: "ES"},
            // { name: 'Slovakia', selected: false, region: "eu" , value: "CS"},
            { name: 'sweden', selected: false, region: "eu" , value: "SE"},
            { name: 'switzerland', selected: false, region: "eu", value: "CH" },
            { name: 'united_kingdom', selected: false, region: "eu", value: "GB" },
            { name: 'australia', selected: false, region: "ap", value: "AU" },
            { name: 'hong_kong', selected: false, region: "ap", value: "HK" },
            { name: 'india', selected: false, region: "ap", value: "IN" },
            { name: 'japan', selected: false, region: "ap", value: "JP" },
            { name: 'singapore', selected: false, region: "ap", value: "SG" },
            { name: 'south_korea', selected: false, region: "ap", value: "KR" },
            { name: 'taiwan', selected: false, region: "ap", value: "TW" },
            { name: 'south_africa', selected: false, region: "af", value: "ZA" },
            { name: 'global', selected: false, region: "global", value: "global" },
        ],
        productTypes: [
            { name: "stocks", symbol: "STK", description: "Stocks", selected: false },
            { name: "etfs", symbol: "ETF", description: "ETF", selected: false },
            { name: "options", symbol: "OPT", description: "Options", selected: false },
            { name: "futures", symbol: "FUT", description: "Futures", selected: false },
            { name: "options_on_futures", symbol: "FOP", description: "Options on Futures", selected: false },
            { name: "bonds", symbol: "BOND", description: "Bonds", selected: false },
            { name: "warrants", symbol: "WAR", description: "Warrants", selected: false },
            { name: "cfd", symbol: "CFD", description: "CFD", selected: false },
            { name: "currencies", symbol: "CASH", description: "Currencies", selected: false },
            { name: "mutual_funds", symbol: "FUND", description: "Mutual Funds", selected: false },
            { name: "metals", symbol: "CMDTY", description: "Metals", selected: false },
            { name: "cryptocurrency", symbol: "CRYPTO", description: "Cryptocurrency", selected: false },
            { name: "structured_products", symbol: "IOPT", description: "Structured Products", selected: false },
            //event contracts
            //hedge funds
            { name: "indices", symbol: "IND", description: "Indices", selected: false },
        ],
        countries: [
            { value: "AD", name:"Andorra", selected: false },
            { value: "AE", name:"United Arab Emirates", selected: false },
            { value: "AF", name:"Afghanistan", selected: false },
            { value: "AG", name:"Antigua and Barbuda", selected: false },
            { value: "AI", name:"Anguilla", selected: false },
            { value: "AL", name:"Albania", selected: false },
            { value: "AM", name:"Armenia", selected: false },
            { value: "AN", name:"Netherlands Antilles", selected: false },
            { value: "AO", name:"Angola", selected: false },
            { value: "AQ", name:"Antartica", selected: false },
            { value: "AR", name:"Argentina", selected: false },
            { value: "AS", name:"American Samoa", selected: false },
            { value: "AT", name:"Austria", selected: false },
            { value: "AU", name:"Australia", selected: false },
            { value: "AW", name:"Aruba", selected: false },
            { value: "AZ", name:"Azerbaijan", selected: false },
            { value: "BA", name:"Bosnia and Herzegowina", selected: false },
            { value: "BB", name:"Barbados", selected: false },
            { value: "BD", name:"Bangladesh", selected: false },
            { value: "BE", name:"Belgium", selected: false },
            { value: "BF", name:"Burkina Faso", selected: false },
            { value: "BG", name:"Bulgaria", selected: false },
            { value: "BH", name:"Bahrain", selected: false },
            { value: "BI", name:"Burundi", selected: false },
            { value: "BJ", name:"Benin", selected: false },
            { value: "BM", name:"Bermuda", selected: false },
            { value: "BN", name:"Brunei Darussalam", selected: false },
            { value: "BO", name:"Bolivia", selected: false },
            { value: "BR", name:"Brazil", selected: false },
            { value: "BS", name:"Bahamas", selected: false },
            { value: "BT", name:"Bhutan", selected: false },
            { value: "BV", name:"Bouvet Island", selected: false },
            { value: "BW", name:"Botswana", selected: false },
            { value: "BY", name:"Belarus", selected: false },
            { value: "BZ", name:"Belize", selected: false },
            { value: "CA", name:"Canada", selected: false },
            { value: "CD", name:"Congo", selected: false },
            { value: "CF", name:"Central African Republic", selected: false },
            { value: "CG", name:"Congo", selected: false },
            { value: "CH", name:"Switzerland", selected: false },
            { value: "CI", name:"Cote d'Ivoire", selected: false },
            { value: "CK", name:"Cook Island", selected: false },
            { value: "CL", name:"Chile", selected: false },
            { value: "CM", name:"Cameroon", selected: false },
            { value: "CN", name:"China", selected: false },
            { value: "CO", name:"Colombia", selected: false },
            { value: "CR", name:"Costa Rica", selected: false },
            { value: "CS", name:"Czechoslovakia (former)", selected: false },
            { value: "CU", name:"Cuba", selected: false },
            { value: "CV", name:"Cape Verde", selected: false },
            { value: "CY", name:"Cyprus", selected: false },
            { value: "CZ", name:"Czech Republic", selected: false },
            { value: "DE", name:"Germany", selected: false },
            { value: "DJ", name:"Djibouti", selected: false },
            { value: "DK", name:"Denmark", selected: false },
            { value: "DM", name:"Dominica", selected: false },
            { value: "DO", name:"Dominican Republic", selected: false },
            { value: "DZ", name:"Algeria", selected: false },
            { value: "EC", name:"Ecuador", selected: false },
            { value: "EE", name:"Estonia", selected: false },
            { value: "EG", name:"Egypt", selected: false },
            { value: "EH", name:"Western Sahara", selected: false },
            { value: "ER", name:"Eritrea", selected: false },
            { value: "ES", name:"Spain", selected: false },
            { value: "ET", name:"Ethiopia", selected: false },
            { value: "EU", name:"European Union", selected: false },
            { value: "FI", name:"Finland", selected: false },
            { value: "FJ", name:"Fiji", selected: false },
            { value: "FK", name:"Falkland Islands (Malvinas)", selected: false },
            { value: "FM", name:"Micronesia", selected: false },
            { value: "FO", name:"Faroe Islands", selected: false },
            { value: "FR", name:"France", selected: false },
            { value: "GA", name:"Gabon", selected: false },
            { value: "GB", name:"Great Britain", selected: false },
            { value: "GD", name:"Grenada", selected: false },
            { value: "GE", name:"GEORGIA", selected: false },
            { value: "GH", name:"Ghana", selected: false },
            { value: "GI", name:"Gibraltar", selected: false },
            { value: "GL", name:"Greenland", selected: false },
            { value: "GM", name:"Gambia", selected: false },
            { value: "GN", name:"Guinea", selected: false },
            { value: "GP", name:"Guadeloupe", selected: false },
            { value: "GQ", name:"Equatorial Guinea", selected: false },
            { value: "GR", name:"Greece", selected: false },
            { value: "GT", name:"Guatemala", selected: false },
            { value: "GU", name:"Guam", selected: false },
            { value: "GW", name:"Guinea-Bissau", selected: false },
            { value: "GY", name:"Guyana", selected: false },
            { value: "HK", name:"Hong Kong", selected: false },
            { value: "HM", name:"Heard Island and McDonald Islands", selected: false },
            { value: "HN", name:"Honduras", selected: false },
            { value: "HR", name:"Croatia", selected: false },
            { value: "HT", name:"Haiti", selected: false },
            { value: "HU", name:"Hungary", selected: false },
            { value: "ID", name:"Indonesia", selected: false },
            { value: "IE", name:"Ireland", selected: false },
            { value: "IL", name:"Israel", selected: false },
            { value: "IN", name:"India", selected: false },
            { value: "IO", name:"British Indian Ocean Territory", selected: false },
            { value: "IQ", name:"Iraq", selected: false },
            { value: "IR", name:"Iran", selected: false },
            { value: "IS", name:"Iceland", selected: false },
            { value: "IT", name:"Italy", selected: false },
            { value: "JM", name:"Jamaica", selected: false },
            { value: "JO", name:"Jordan", selected: false },
            { value: "JP", name:"Japan", selected: false },
            { value: "KE", name:"Kenya", selected: false },
            { value: "KG", name:"Kyrgyzstan", selected: false },
            { value: "KH", name:"Cambodia", selected: false },
            { value: "KI", name:"Kiribati", selected: false },
            { value: "KM", name:"Comoros", selected: false },
            { value: "KN", name:"Saint Kitts and Nevis", selected: false },
            { value: "KP", name:"North Korea", selected: false },
            { value: "KR", name:"South Korea", selected: false },
            { value: "KW", name:"Kuwait", selected: false },
            { value: "KY", name:"Cayman Islands", selected: false },
            { value: "KZ", name:"Kazakstan", selected: false },
            { value: "LA", name:"Lao People's Democratic Republic", selected: false },
            { value: "LB", name:"Lebanon", selected: false },
            { value: "LC", name:"Saint Lucia", selected: false },
            { value: "LI", name:"Liechtenstein", selected: false },
            { value: "LK", name:"Sri Lanka", selected: false },
            { value: "LR", name:"Liberia", selected: false },
            { value: "LS", name:"Lesotho", selected: false },
            { value: "LT", name:"Lithuania", selected: false },
            { value: "LU", name:"Luxembourg", selected: false },
            { value: "LV", name:"Latvia", selected: false },
            { value: "LY", name:"Libyan Arab Jamahiriya", selected: false },
            { value: "MA", name:"Morocco", selected: false },
            { value: "MC", name:"Monaco", selected: false },
            { value: "MD", name:"Moldova", selected: false },
            { value: "MG", name:"Madagascar", selected: false },
            { value: "MH", name:"Marshall Islands", selected: false },
            { value: "MK", name:"Macedonia", selected: false },
            { value: "ML", name:"Mali", selected: false },
            { value: "MM", name:"Myanmar", selected: false },
            { value: "MN", name:"Mongolia", selected: false },
            { value: "MO", name:"Macau", selected: false },
            { value: "MP", name:"Northern Mariana Islands", selected: false },
            { value: "MQ", name:"Martinique", selected: false },
            { value: "MR", name:"Mauritania", selected: false },
            { value: "MS", name:"Montserrat", selected: false },
            { value: "MT", name:"Malta", selected: false },
            { value: "MU", name:"Mauritius", selected: false },
            { value: "MV", name:"Maldives", selected: false },
            { value: "MW", name:"Malawi", selected: false },
            { value: "MX", name:"Mexico", selected: false },
            { value: "MY", name:"Malaysia", selected: false },
            { value: "MZ", name:"Mozambique", selected: false },
            { value: "NA", name:"Namibia", selected: false },
            { value: "NC", name:"New Caledonia", selected: false },
            { value: "NE", name:"Niger", selected: false },
            { value: "NG", name:"Nigeria", selected: false },
            { value: "NI", name:"Nicaragua", selected: false },
            { value: "NL", name:"Netherlands", selected: false },
            { value: "NO", name:"Norway", selected: false },
            { value: "NP", name:"Nepal", selected: false },
            { value: "NR", name:"Nauru", selected: false },
            { value: "NZ", name:"New Zealand", selected: false },
            { value: "OM", name:"Oman", selected: false },
            { value: "PA", name:"Panama", selected: false },
            { value: "PE", name:"Peru", selected: false },
            { value: "PF", name:"French Polynesia", selected: false },
            { value: "PG", name:"Papua New Guinea", selected: false },
            { value: "PH", name:"Philippines", selected: false },
            { value: "PK", name:"Pakistan", selected: false },
            { value: "PL", name:"Poland", selected: false },
            { value: "PR", name:"Puerto Rico", selected: false },
            { value: "PS", name:"Palestinian Territory", selected: false },
            { value: "PT", name:"Portugal", selected: false },
            { value: "PW", name:"Palau", selected: false },
            { value: "PY", name:"Paraguay", selected: false },
            { value: "QA", name:"Quatar", selected: false },
            { value: "RE", name:"Reunion", selected: false },
            { value: "RO", name:"Romania", selected: false },
            { value: "RU", name:"Russian Federation", selected: false },
            { value: "RW", name:"Rwanda", selected: false },
            { value: "SA", name:"Saudi Arabia", selected: false },
            { value: "SB", name:"Solomon Islands", selected: false },
            { value: "SC", name:"Seychelles", selected: false },
            { value: "SD", name:"Sudan", selected: false },
            { value: "SE", name:"Sweden", selected: false },
            { value: "SG", name:"Singapore", selected: false },
            { value: "SI", name:"Slovenia", selected: false },
            { value: "SK", name:"Slovekia", selected: false },
            { value: "SL", name:"Sierra Leone", selected: false },
            { value: "SM", name:"San Marino", selected: false },
            { value: "SN", name:"Senegal", selected: false },
            { value: "SO", name:"Somalia", selected: false },
            { value: "SR", name:"Suriname", selected: false },
            { value: "ST", name:"Sao Tome and Principe", selected: false },
            { value: "SV", name:"El Salvador", selected: false },
            { value: "SY", name:"Syrian Arab Republic", selected: false },
            { value: "SZ", name:"Swaziland", selected: false },
            { value: "TC", name:"Turks and Caicos Islands", selected: false },
            { value: "TD", name:"Chad", selected: false },
            { value: "TF", name:"French Southern Territories", selected: false },
            { value: "TG", name:"Togo", selected: false },
            { value: "TH", name:"Thailand", selected: false },
            { value: "TJ", name:"Tajikistan", selected: false },
            { value: "TK", name:"Tokelau", selected: false },
            { value: "TM", name:"Turkmenistan", selected: false },
            { value: "TN", name:"Tunisia", selected: false },
            { value: "TO", name:"Tonga", selected: false },
            { value: "TP", name:"East Timor", selected: false },
            { value: "TR", name:"Turkey", selected: false },
            { value: "TT", name:"Trinidad and Tobago", selected: false },
            { value: "TV", name:"Tuvalu", selected: false },
            { value: "TW", name:"Taiwan", selected: false },
            { value: "TZ", name:"Tanzania", selected: false },
            { value: "UA", name:"Ukraine", selected: false },
            { value: "UG", name:"Uganda", selected: false },
            { value: "GB", name:"United Kingdom", selected: false },
            { value: "UM", name:"United States Minor Outlying Islands", selected: false },
            { value: "US", name:"United States", selected: false },
            { value: "UY", name:"Uruguay", selected: false },
            { value: "UZ", name:"Uzbekistan", selected: false },
            { value: "VA", name:"Holy See (Vatican City State)", selected: false },
            { value: "VC", name:"Saint Vincent and the Grenadines", selected: false },
            { value: "VE", name:"Venezuela", selected: false },
            { value: "VI", name:"Virgin Islands", selected: false },
            { value: "VN", name:"Viet Nam", selected: false },
            { value: "VU", name:"Vanuatu", selected: false },
            { value: "WF", name:"Wallis and Futuna", selected: false },
            { value: "WS", name:"Samoa", selected: false },
            { value: "YE", name:"Yemen", selected: false },
            { value: "YU", name:"Serbia and Montenegro", selected: false },
            { value: "ZA", name:"South Africa", selected: false },
            { value: "ZM", name:"Zambia", selected: false },
            { value: "ZW", name:"Zimbabwe" }
        ],
        orderTypes: [
            { type: "Limit", url: "http://www.interactivebrokers.com/en/trading/orders/limit.php" },
            { type: "Adjustable Stop", url: "http://www.interactivebrokers.com/en/trading/orders/adjustable-stop.php" },
            { type: "Basket", url: "http://www.interactivebrokers.com/en/trading/orders/basket.php" },
            { type: "Conditional", url: "http://www.interactivebrokers.com/en/trading/orders/conditional.php" },
            { type: "Good After Time", url: "http://www.interactivebrokers.com/en/trading/orders/gat.php" },
            { type: "Good Till Cancel", url: "http://www.interactivebrokers.com/en/trading/orders/gtc.php" },
            { type: "Good Till Time", url: "http://www.interactivebrokers.com/en/trading/orders/gtd.php" },
            { type: "Hidden", url: "http://www.interactivebrokers.com/en/trading/orders/hidden.php" },
            { type: "Market", url: "http://www.interactivebrokers.com/en/trading/orders/market.php" },
            { type: "One Cancels All", url: "http://www.interactivebrokers.com/en/trading/orders/oca.php" },
            { type: "Scale", url: "http://www.interactivebrokers.com/en/trading/orders/scale.php" },
            { type: "Limit If Touched", url: "http://www.interactivebrokers.com/en/trading/orders/lit.php" },
            { type: "Market If Touched", url: "http://www.interactivebrokers.com/en/trading/orders/mit.php" },
            { type: "Market To Limit", url: "http://www.interactivebrokers.com/en/trading/orders/mtl.php" },
            { type: "Pegged To Benchmark", url: "http://www.interactivebrokers.com/en/trading/orders/pegged-to-benchmark.php" },
            { type: "Trailing Stop", url: "http://www.interactivebrokers.com/en/trading/orders/trailing-stops.php" },
            { type: "Trailing Limit If Touched", url: "http://www.interactivebrokers.com/en/trading/orders/trailing-limit-touched.php" },
            { type: "Trailing Stop Limit", url: "http://www.interactivebrokers.com/en/trading/orders/trailing-stop-limit.php" },
            { type: "Trailing Market If Touched", url: "http://www.interactivebrokers.com/en/trading/orders/trailing-market-touched.php" },
            { type: "Good Till Date", url: "http://www.interactivebrokers.com/en/trading/orders/gtd.php" },
            { type: "Stop", url: "http://www.interactivebrokers.com/en/trading/orders/stop.php" },
            { type: "Stop Limit", url: "http://www.interactivebrokers.com/en/trading/orders/stop-limit.php" },
            { type: "Discretionary", url: "http://www.interactivebrokers.com/en/trading/orders/discretionary.php" },
            { type: "Limit On Close", url: "http://www.interactivebrokers.com/en/trading/orders/loc.php" },
            { type: "Limit On Open", url: "http://www.interactivebrokers.com/en/trading/orders/loo.php" },
            { type: "Market On Close", url: "http://www.interactivebrokers.com/en/trading/orders/moc.php" },
            { type: "Market On Open", url: "http://www.interactivebrokers.com/en/trading/orders/moo.php" },
            { type: "Relative/Pegged To Primary", url: "http://www.interactivebrokers.com/en/trading/orders/pegged-to-primary.php" },
            { type: "Volatility", url: "http://www.interactivebrokers.com/en/trading/orders/volatility.php" },
            { type: "Iceberg", url: "http://www.interactivebrokers.com/en/trading/orders/iceberg.php" },
            { type: "Pegged To Stock", url: "http://www.interactivebrokers.com/en/trading/orders/pegged-to-stock.php" },
            { type: "All Or None", url: "http://www.interactivebrokers.com/en/trading/orders/aon.php" },
            { type: "Partial All Or None", url: "Not Available" },
            { type: "Quote Request", url: "http://www.interactivebrokers.com/en/trading/orders/rfq.php" },
            { type: "Immediate Or Cancel", url: "http://www.interactivebrokers.com/en/trading/orders/ioc.php" },
            { type: "Fill Or Kill", url: "http://www.interactivebrokers.com/en/trading/orders/fok.php" },
            { type: "Auction", url: "http://www.interactivebrokers.com/en/trading/orders/price-improvement-auction-orders.php" },
            { type: "Pegged-to-Midpoint", url: "http://www.interactivebrokers.com/en/trading/orders/ibusopt-pegmid.php" },
            { type: "Retail Price Improvement", url: "http://www.interactivebrokers.com/en/trading/orders/rpi.php" },
            { type: "Sweep", url: "http://www.interactivebrokers.com/en/trading/orders/sweep-to-fill.php" },            
        ],
        domains: [
            { domainName: "com", allowedProductTypes: ["stocks", "bonds", "metals", "options", "mutual_funds", "warrants", "futures", "etfs", "structured_products", "options_on_futures", "cryptocurrency", "indices", "currencies"] },
            { domainName: "ca", allowedProductTypes: ["stocks", "bonds", "options", "warrants", "futures", "etfs", "options_on_futures", "indices", "currencies"] },
            { domainName: "uk", allowedProductTypes: ["stocks", "bonds", "cfd", "metals", "options", "mutual_funds", "warrants", "futures", "etfs", "structured_products", "options_on_futures", "indices", "currencies"] },
            { domainName: "ie", allowedProductTypes: ["stocks", "bonds", "cfd", "metals", "options", "mutual_funds", "warrants", "futures", "etfs", "structured_products", "options_on_futures", "indices", "currencies"] },
            { domainName: "hu", allowedProductTypes: ["stocks", "bonds", "cfd", "options", "mutual_funds", "warrants", "futures", "etfs", "structured_products", "options_on_futures", "indices"] },
            { domainName: "au", allowedProductTypes: ["stocks", "bonds", "cfd", "options", "warrants", "futures", "etfs", "options_on_futures", "indices", "currencies"] },
            { domainName: "hk", allowedProductTypes: ["stocks", "bonds", "options", "mutual_funds", "warrants", "futures", "etfs", "options_on_futures", "cryptocurrency", "indices", "currencies"] },
            { domainName: "in", allowedProductTypes: ["stocks", "bonds", "metals", "options", "mutual_funds", "warrants", "futures", "etfs", "structured_products", "options_on_futures", "indices", "currencies"] },
            { domainName: "jp", allowedProductTypes: ["stocks", "cfd", "options", "futures", "etfs", "options_on_futures"] },
            { domainName: "sg", allowedProductTypes: ["stocks", "bonds", "cfd", "options", "mutual_funds", "warrants", "futures", "etfs", "structured_products", "options_on_futures", "indices", "currencies"] },
        ],
        restrictedProductTypes : [
            { domainName: "com", productTypes: ["CFD"], name: ["CFD"] },
            { domainName: "ca", productTypes: ["CMDTY", "FUND", "CRYPTO", "CFD", "IOPT"], name: ["Metals", "Mutual Funds", "Cryptocurrency", "CFD", "Structured Products"] },
            { domainName: "uk", productTypes: ["CRYPTO"], name: ["Cryptocurrency"] },
            { domainName: "ie", productTypes: ["CRYPTO"], name: ["Cryptocurrency"] },
            { domainName: "hu", productTypes: ["CMDTY", "CASH", "CRYPTO"], name: ["Metals", "Currencies", "Cryptocurrency"] },
            { domainName: "au", productTypes: ["CRYPTO", "IOPT", "CMDTY", "FUND"], name: ["Cryptocurrency", "Structured Products", "Metals", "Mutual Funds"] },
            { domainName: "hk", productTypes: ["CMDTY", "IOPT", "CFD"], name: ["Metals", "Structured Products", "CFD"] },
            { domainName: "in", productTypes: ["CRYPTO", "CFD"], name: ["Cryptocurrency", "CFD"] },
            { domainName: "sg", productTypes: ["CMDTY", "CRYPTO"], name: ["Metals", "Cryptocurrency"] },
            { domainName: "jp", productTypes: ["BOND", "CMDTY", "FUND", "WAR", "IOPT", "CRYPTO", "IND", "CASH"], name: ["Bonds", "Metals", "Mutual Funds", "Warrants", "Structured Products", "Cryptocurrency", "Indices", "Currencies"] },
        ],
        restrictedExchanges : ["SGXCME"],
        restrictedProducts: [
            {symbol: 'GC', description: 'Gold', type: 'FUT', domain: 'jp'},
            {symbol: 'MGC', description: 'E-Micro Gold', type: 'FUT', domain: 'jp'},
            {symbol: 'SI', description: 'Silver Index', type: 'FUT', domain: 'jp'},
            {symbol: 'GOLD', description: 'Gold (Standard) - Japan', type: 'FUT', domain: 'jp'},
            {symbol: 'M-GD', description: 'Gold (Mini) - Japan', type: 'FUT', domain: 'jp'},
            {symbol: 'M-PT', description: 'Platinum (Mini) - Japan', type: 'FUT', domain: 'jp'},
            {symbol: 'PLAT', description: 'Platinum (Standard) - Japan ', type: 'FUT', domain: 'jp'},
            {symbol: 'RSS3', description: 'Ribbed Smoked Sheet (RSS) No.3 Rubber', type: 'FUT', domain: 'jp'},
            {symbol: 'TGCN', description: 'Corn - Japan', type: 'FUT', domain: 'jp'},
            {symbol: 'TONA', description: '3 month compounded TONA', type: 'FUT', domain: 'jp'}
        ],
        signUpTrackingURLs : [
            { domain: "com", url: "https://www.interactivebrokers.com/mkt/?src=ibkrpeqd&url=%2Fen%2Findex.php%3Ff%3D4695"},
            { domain: "sg", url: "https://www.interactivebrokers.com.sg/mkt/?src=ibkrpeqd1&url=%2Fen%2Findex.php%3Ff%3D4695"},
            { domain: "hk", url: "https://www.interactivebrokers.com.hk/mkt/?src=ibkrpeqd2&url=%2Fen%2Findex.php%3Ff%3D4695"},
            { domain: "ca", url: "https://www.interactivebrokers.ca/mkt/?src=ibkrpeqd3&url=%2Fen%2Findex.php%3Ff%3D4695"},
            { domain: "au", url: "https://www.interactivebrokers.com.au/mkt/?src=ibkrpeqd4&url=%2Fen%2Findex.php%3Ff%3D43400"},
            { domain: "uk", url: "https://www.interactivebrokers.co.uk/mkt/?src=ibkrpeqd5&url=%2Fen%2Findex.php%3Ff%3D41364"},
            { domain: "in", url: "https://www.interactivebrokers.co.in/mkt/?src=ibkrpeqd6&url=%2Fen%2Findex.php%3Ff%3D41364"},
            { domain: "ie", url: "https://www.interactivebrokers.ie/mkt/?src=ibkrpeqd7&url=%2Fen%2Findex.php%3Ff%3D41364"},
            { domain: "hu", url: "https://www.interactivebrokers.hu/mkt/?src=ibkrpeqd8&url=%2Fen%2Findex.php%3Ff%3D41364"},
        ]
    },
    mutations: {
        setPreventSearch(state, value) {
            state.preventSearch = value;
        },
        setTab(state, value) {
            state.selectedTab = value;
        },
        setSelectedCountry(state, country) {
            state.selectedCountry = country;
        },
        setSelectedRegion(state, region) {
            if(region.length === 0){
                state.selectedRegion = region;    
            } else {
                state.selectedRegion.push(region);    
            }
        },
        removeSelectedRegion(state, regionName) {
            const region = cloneDeep(state.selectedRegion);
            let index = region.indexOf(regionName);
            region.splice(index, 1)
            state.selectedRegion = region;
        },
        setSelectedProduct(state, product) {
            state.selectedProduct = product;
        },
        setProductType(state, { index, productType }) {
            Vue.set(state.productTypes, index, productType);
        },
        setProdTypes(state, prodTypes){
            state.productTypes = prodTypes;
        },
        setProductTypes(state, productTypes) {
            state.productTypes = productTypes;
        },
        setDefaultRegion(state, tab) {
            state.defaultRegion = tab;
        },
        setDefaultOption(state, option) {
            state.defaultOption = option;
        },
        setRegion(state, { index, region }) {
            Vue.set(state.regions, index, region);
        },
        setRegn(state, regn){
            state.regions = regn;
        },
        setRegions(state, regions) {
            state.regions = regions;
        },
        setStatus(state, status) {
            state.status = status;
        },
        setApiStatus(state, status) {
            state.apiStatus = status;
        },
        setShowWarning(state, status) {
            state.showWarning = status;
        },
        setListedResults(state, results) {
            state.listedResults = results;
        },
        setFilteredExchangeResults(state, results) {
            state.filteredExchangeResults = results;
        },
        setProductResults(state, results) {
            state.productResults = results;
        },
        setSearchResults(state, results) {
            state.searchResults = results;
        },
        setOrderTypesResults(state, orderTypes) {
            state.orderTypesResults = orderTypes;
        },
        setExchanges(state, exchanges) {
            state.exchanges = exchanges;
        },
        setSelectedExchange(state, exchange) {
            state.selectedExchange = exchange;
        },
        setselectedExch(state, exchange) {
            state.selectedExch = exchange;
        },
        setSelectedProductType(state, productType) {
            state.selectedProductType = productType;
        },
        setSearchProductType(state, types) {
            if(types.length === 0){
                state.searchProductType = types;  
            } else {
                state.searchProductType.push(types);
            }
        },
        setFilteredResults(state, result) {
            if(result.length === 0){
                state.filteredResults = [];
            } else {
                state.filteredResults.push(result);
            }
        },
        setCountries(state, {index, value}){
            state.filteredResults[index].country = value;
        },
        removeSearchProductType(state, type) {
            const types = cloneDeep(state.searchProductType);
            let index = types.indexOf(type);
            types.splice(index, 1)
            state.searchProductType = types;
        },
        setProducts(state, products) {
            state.products = products;
        },
        setTypesList(state, types) {
            state.typesList = types;
        },
        setTotalPages(state, pages) {
            state.totalPages = pages;
        },
        setPageNumber(state, page) {
            state.pageNumber = page;
        },
        setNumShow(state, num) {
            state.numShow = num;
        },
        setNewProducts(state, newProduct){
            state.newProducts = newProduct;
        },
        setResultStatus(state, status){
            state.resultStatus = status;
        },
        setApiTestResponse(state, response) {
            state.apiTestResponse = response;
        },
        setUserSelection(state, response) {
            state.userSelection = response
        },
        setSecDefData(state, result) {
            if(result.length === 0){
                state.secDefData = [];
            } else {
                state.secDefData.push(result);
            }
        },
        setPreviousSort(state, value){
            state.previousSort = value;
        },
        setCurrentSort(state, value){
            state.currentSort = value;
        },
        setSearchTerm(state, value){
            state.searchTerm = value;
        },
        setUseSearchTerm(state, value){
            state.useSearchTerm = value;
        },
        seti158Restrictions(state, result) {
            state.i158Restrictions = result;
        },
    },
    actions: {
        setPreventSearch({ commit }, value) {
           commit('setPreventSearch', value);
        },
        setTab({ commit }, value) {
            commit('setTab', value);
        },
        setSelectedRegion({ commit }, country) {
            commit('setSelectedRegion', country);
        },
        setSearchProductType({ commit }, type) {
            commit('setSearchProductType', type);
        },
        setFilteredResults({ commit }, result) {
            commit('setFilteredResults', result);
        },
        setCountries({ commit }, {index, value}) {
            commit('setCountries', {index, value});
        },
        setSelectedCountry({commit}, country) {
            commit('setSelectedCountry', country);
        },
        setSelectedProduct({commit}, product) {
            commit('setSelectedProduct', product);
        },
        setDefaultRegion({ commit }, tab) {
            commit('setDefaultRegion', tab);
        },
        setDefaultOption({ commit }, tab) {
            commit('setDefaultOption', tab);
        },
        setRegion({ commit }, { index, region }) {
            commit('setRegion', { index, region });
        },
        setRegn({ commit }, regn){
            commit('setRegn', regn);
        },
        setRegions({ commit }, regions) {
            commit('setRegions', regions);
        },
        setProductType({ commit }, { index, productType }) {
            commit('setProductType', { index, productType });
        },
        setProdTypes({ commit }, prodTypes){
            commit('setProdType', prodTypes);
        },
        setProductTypes({ commit }, productTypes) {
            commit('setProductTypes', productTypes);
        },
        setStatus({commit}, status) {
            commit('setStatus', status);
        },
        setApiStatus({commit}, status) {
            commit('setApiStatus', status);
        },
        setShowWarning({commit}, status) {
            commit('setShowWarning', status);
        },
        setListedResults({commit},results) {
            commit('setListedResults', results);
        },
        setFilteredExchangeResults({commit},results) {
            commit('setFilteredExchangeResults', results);
        },
        setProductResults({commit},results) {
            commit('setProductResults', results);
        },
        setSearchResults({commit},results) {
            commit('setSearchResults', results);
        },
        setOrderTypesResults({commit},orderTypes) {
            commit('setOrderTypesResults', orderTypes);
        },
        setExchanges({commit}, exchanges) {
            commit('setExchanges', exchanges);
        },
        setSelectedExchange({commit}, exchange) {
            commit('setSelectedExchange', exchange);
        },
        setselectedExch({commit}, exchange) {
            commit('setselectedExch', exchange);
        },
        setSelectedProductType({commit}, productType) {
            commit('setSelectedProductType', productType);
        },
        setProducts({commit}, products) {
            commit('setProducts', products);
        },
        setTypesList({commit}, types) {
            commit('setTypesList', types);
        },
        setTotalPages({commit}, pages) {
            commit('setTotalPages', pages);
        },
        setPageNumber({commit}, page) {
            commit('setPageNumber', page);
        },
        setNumShow({commit}, num) {
            commit('setNumShow', num);
        },
        setNewProducts({commit}, newProduct){
            commit('setNewProducts',newProduct);
        },
        setResultStatus({commit}, status){
            commit('setResultStatus',status);
        },
        setApiTestResponse({commit}, response) {
            commit('setApiTestResponse', response);
        },
        setUserSelection({commit}, response) {
            commit('setUserSelection', response);
        },
        setSecDefData({commit}, response){
            commit('setSecDefData', response);
        },
        setPreviousSort({commit}, value){
            commit('setPreviousSort', value);
        },
        setCurrentSort({commit}, value){
            commit('setCurrentSort', value);
        },
        setSearchTerm({commit}, value){
            commit('setSearchTerm', value);
        },
        setUseSearchTerm({commit}, value){
            commit('setUseSearchTerm', value);
        },
        seti158Restrictions({commit}, response) {
            commit('seti158Restrictions', response);
        },
        reset({commit, state}){
            if(state.selectedTab === 'products'){
                commit('setTab', 'products');
            } else if(state.selectedTab === 'exchanges'){
                commit('setTab', 'exchanges');
            } else {
                commit('setTab', 'contracts');
            }
            commit('setSelectedCountry','');
            commit('setStatus', 'selected');
            commit('setListedResults', []);
            commit('setProductResults', []);
            commit('setselectedExch', '');
            commit('setSelectedExchange', '');
            commit('setTypesList', []);
            commit('setSelectedProductType', '');
            // commit('setSelectedRegion', []);
            commit('setSearchProductType', []);
            commit('setNewProducts', 'all');
            commit('setSelectedProduct', '');
            commit('setPageNumber', 1)
            commit('setNumShow', 'Show 100 Rows');
            commit('setTotalPages', '');
            commit('setDefaultOption', 'products');
            commit('setUserSelection', false);
            commit('setSecDefData', '');
            commit('setCurrentSort', { type: 'symbol', dir: 'asc' });
            commit('setSearchTerm', '');
            commit('setUseSearchTerm', false);
            commit('setShowWarning', false);

            // const newRegions = cloneDeep(state.regions);
            // newRegions.forEach(region => region.selected = false);
            // commit('setRegions', newRegions);

            const newProductTypes = cloneDeep(state.productTypes);
            newProductTypes.forEach(product => product.selected = false);
            commit('setProductTypes', newProductTypes);
        },
        filterProductTypes({state, commit, dispatch, getters}, response) {
            dispatch('setFilteredResults', '');
            response.map(res => {
                let filteredTypeList = [];
                const results = cloneDeep(state.filteredResults);
                let productTypeList = res['assets'].split(',');
                let restrictedTypes = state.restrictedProductTypes.filter(t => t['domainName'] === getters.selectedDomain).map(t => t['name']);
                
                // Search and remove restricted product types
                productTypeList.filter(type => {
                    if(!restrictedTypes[0].includes(type)){
                        filteredTypeList.push(type);
                    }
                });

                if(filteredTypeList.length != 0 && !state.restrictedExchanges.includes(res.id)){
                    res['assets'] = filteredTypeList.join();
                    if(state.status === "selected" && !state.filteredResults.map(result => result.id).includes(res.id)){
                        if(res.id === "GETTEX"){
                            res.name = "Boerse Muenchen";
                        }
                        dispatch('setFilteredResults', res);
                    } else if(state.status === "loading") {
                        if(state.filteredResults.length === 0){
                            if(res.id === "GETTEX"){
                                res.name = "Boerse Muenchen";
                            }
                            dispatch('setFilteredResults', res);
                        } else {
                            if(state.filteredResults.map((result) => result.id).includes(res.id)){
                                let index = state.filteredResults.findIndex(result => {
                                    return result.id === res.id;
                                })
                                let value = state.filteredResults[index].country + ", " + res.country;
                                dispatch('setCountries', {index, value});
                            } else {
                                if(res.id === "GETTEX"){
                                    res.name = "Boerse Muenchen";
                                }
                                dispatch('setFilteredResults', res);
                            }
                        }
                    }
                }
            })
        },
        search({state, dispatch, getters}) {
            if(state.selectedExchange.length != 0 && state.selectedRegion.length != 0) {
                if(state.userSelection === true){
                    return dispatch('searchByCntryNameAndExchId');
                } else {
                    dispatch('reset');
                    $alert('To complete your search, enter yours search term and select from the listed exchanges.');
                }
            } else if(state.selectedRegion.length != 0 && state.searchProductType.length === 0 && state.selectedTab === 'exchanges') {
                return dispatch('searchExchangeByCountryName');
            } else if(state.selectedExchange.length != 0) {
                return dispatch('searchExchangeByExchangeId');
            } else if((state.searchProductType.length != 0 || state.selectedRegion.length != 0 
                || state.selectedProduct.length != 0 || state.newProducts.length != 0) && state.selectedTab === 'products') {
                return dispatch('searchByFilters');
            }
        },
        searchExchangeByCountryName({commit, dispatch, getters, state}) {
            return new Promise((resolve, reject) => {
                const payload = {
                    pageNumber: state.pageNumber,
                    pageSize: state.numShow.split(' ')[1],
                    sortField: state.currentSort.type,
                    sortDirection: state.currentSort.dir,
                    country_code: state.selectedRegion,
                }
                
                api.fetchExchangeDetails(payload)
                    .then(response => {
                        if(response.exchanges.length === 0){
                            $alert('No results found');
                            const regns = cloneDeep(state.regions);
                            regns.forEach((reg) => {
                                state.selectedRegion.forEach((val) => {
                                    if(reg.value === val){
                                        reg.selected = !reg.selected;
                                    }
                                });
                            }); 
                            commit('setRegn', regns);
                            commit('setSelectedRegion', []);
                            commit('setDefaultRegion', 'na');
                            commit('setStatus', 'selected');
                        } else{
                            // let pageCount = response.map(res => res['pageCount']);
                            let pageCount = response.pageCount;
                            
                            // Functionality to populate button group for product type filtering on results page
                            if(state.typesList.length === 0){
                                let prodTypes = [];
                                
                                for(const [key, value] of Object.entries(response.productTypeCount)){
                                    const pdt = state.productTypes.filter(type => type.description === key);
                                    if(pdt.length){
                                        prodTypes.push({name: pdt[0].name, symbol: pdt[0].symbol, totalCount: value.length});
                                    }
                                }

                                // Sort in product types in a particular order
                                prodTypes.sort((a, b) => getters.preferredProductTypeOrder[a.symbol] - getters.preferredProductTypeOrder[b.symbol]);

                                console.debug("prodTypes: ", prodTypes);
                                
                                commit('setTypesList', prodTypes);
                                commit('setSelectedProductType', 'all');
                            }

                            dispatch('filterProductTypes', response.exchanges);
                            commit('setFilteredExchangeResults', state.filteredResults);

                            // Populate results based on selected product type filter
                            if(state.selectedProductType != 'all'){
                                const pdt = state.productTypes.find(product => product.symbol === state.selectedProductType);
                                const filteredResults = state.filteredExchangeResults.filter(exchange => exchange.assets.includes(pdt.description));
                                commit('setListedResults', filteredResults);
                            } else {
                                commit('setListedResults', state.filteredResults);
                            }

                            if(state.listedResults.length < 100){
                                commit('setResultStatus', false);
                            } else {
                                commit('setResultStatus', true);
                            }
                            commit('setStatus', 'exchangeResults');
                            commit('setTotalPages', state.listedResults.length);
                            commit('setPreviousSort', state.currentSort);
                        }
                    })
                    .catch(error => {
                        console.error(error)
                    });
            })
        },
        searchExchangeByExchangeId({commit, dispatch, getters, state}) {
            let exchangeId = state.exchanges.filter(exchange => exchange.name === state.selectedExchange || exchange.id === state.selectedExchange);
            return new Promise((resolve, reject) => {
                const payload = {
                    pageNumber: state.pageNumber,
                    pageSize: state.numShow.split(' ')[1],
                    sortField: "id",
                    sortDirection: "ASC",
                    sortField: state.currentSort.type,
                    sortDirection: state.currentSort.dir,
                    exchange_id: exchangeId[0].id,
                }
                api.fetchExchangeDetails(payload)
                    .then(response => {
                        if(response.exchanges.length === 0){
                            $alert('No results found');
                            commit('setSelectedExchange', '');
                            commit('setDefaultRegion', 'na');
                            commit('setStatus', 'selected');
                            commit('setUserSelection', false);
                        } else {
                            // let pageCount = response.map(res => res['pageCount']);
                            let pageCount = response.pageCount;
                            if(state.typesList.length === 0){
                                let prodTypes = [];
                                
                                for(const [key, value] of Object.entries(response.productTypeCount)){
                                    const pdt = state.productTypes.filter(type => type.description === key);
                                    if(pdt.length){
                                        prodTypes.push({name: pdt[0].name, symbol: pdt[0].symbol, totalCount: value.length});
                                    }
                                }

                                // Sort in product types in a particular order
                                prodTypes.sort((a, b) => getters.preferredProductTypeOrder[a.symbol] - getters.preferredProductTypeOrder[b.symbol]);
                                
                                commit('setTypesList', prodTypes);
                                commit('setSelectedProductType', 'all');
                            }
                            dispatch('filterProductTypes', response.exchanges);
                            commit('setListedResults', state.filteredResults);
                            commit('setFilteredExchangeResults', state.filteredResults);
                            if(state.listedResults.length < 100){
                                commit('setResultStatus', false);
                            } else {
                                commit('setResultStatus', true);
                            }
                            commit('setStatus', 'exchangeResults');
                            commit('setTotalPages', state.listedResults.length);
                            commit('setPreviousSort', state.currentSort);
                        }
                    })
                    .catch(error => {
                        console.error(error)
                    });
            })
        },
        searchByCntryNameAndExchId({commit, dispatch, getters, state}) {
            let exchangeId = state.exchanges.filter(exchange => exchange.name === state.selectedExchange || exchange.id === state.selectedExchange);
            return new Promise((resolve, reject) => {
                const payload = {
                    pageNumber: state.pageNumber,
                    pageSize: state.numShow.split(' ')[1],
                    sortField: state.currentSort.type,
                    sortDirection: state.currentSort.dir,
                    country_code: state.selectedRegion,
                    exchange_id: exchangeId[0].id,
                }

                // If user does not choose exchange from suggestion dropdown we are showing no results.
                if(state.userSelection === false && state.selectedRegion.length != 0 && state.selectedExchange != 0){
                    $alert('No results found');
                    commit('setSelectedExchange', '');
                    const regns = cloneDeep(state.regions);
                    regns.forEach((reg) => {
                        state.selectedRegion.forEach((val) => {
                            if(reg.value === val){
                                reg.selected = !reg.selected;
                            }
                        });
                    });
                    commit('setRegn', regns);
                    commit('setSelectedRegion', []);
                    commit('setDefaultRegion', 'na');
                    commit('setStatus', 'selected');
                } else {
                    api.fetchExchangeDetails(payload)
                        .then(response => {
                            if(response.exchanges.length === 0){
                                $alert('The selected exchange does not exist for the selected country');
                                commit('setSelectedExchange', '');
                                const regns = cloneDeep(state.regions);
                                regns.forEach((reg) => {
                                    state.selectedRegion.forEach((val) => {
                                        if(reg.value === val){
                                            reg.selected = !reg.selected;
                                        }
                                    });
                                });
                                commit('setRegn', regns);
                                commit('setSelectedRegion', []);
                                commit('setDefaultRegion', 'na');
                                commit('setStatus', 'selected');
                                commit('setUserSelection', false);
                            } else {
                                // let pageCount = response.map(res => res['pageCount']);
                                let pageCount = response.pageCount;
                                if(state.typesList.length === 0){
                                    let prodTypes = [];
                                    
                                    for(const [key, value] of Object.entries(response.productTypeCount)){
                                        const pdt = state.productTypes.filter(type => type.description === key);
                                        if(pdt.length){
                                            prodTypes.push({name: pdt[0].name, symbol: pdt[0].symbol, totalCount: value.length});
                                        }
                                    }
    
                                    // Sort in product types in a particular order
                                    prodTypes.sort((a, b) => getters.preferredProductTypeOrder[a.symbol] - getters.preferredProductTypeOrder[b.symbol]);
                                    
                                    commit('setTypesList', prodTypes);
                                    commit('setSelectedProductType', 'all');
                                }
                                dispatch('filterProductTypes', response.exchanges);
                                commit('setListedResults', state.filteredResults);
                                commit('setFilteredExchangeResults', state.filteredResults);
                                if(state.listedResults.length < 100){
                                    commit('setResultStatus', false);
                                } else {
                                    commit('setResultStatus', true);
                                }
                                commit('setStatus', 'exchangeResults');
                                commit('setTotalPages', state.listedResults.length);
                                commit('setPreviousSort', state.currentSort);
                            }
                        })
                        .catch(error => {
                            console.error(error);
                        });
                }

            })
        },
        searchByFilters({commit, dispatch, getters, state}) {
            return new Promise((resolve, reject) => {
                
                let searchProduct;
                
                if(state.newProducts === 'all'){
                    searchProduct = 'all';
                } else if(state.newProducts === 'existing') {
                    searchProduct = 'F';
                } else {
                    searchProduct = 'T';
                }

                const payload = {
                    pageNumber: state.pageNumber,
                    pageSize: state.numShow.split(' ')[1],
                    sortField: state.currentSort.type,
                    sortDirection: state.currentSort.dir,
                    productCountry: state.selectedRegion,
                    productSymbol: state.selectedProduct,
                    newProduct: searchProduct,
                    productType: state.searchProductType,
                    domain: getters.selectedDomain,
                }
                
                commit('setStatus', 'loading');
                api.getProductsByFilters(payload)
                    .then(response => {
                        if (response.products.length === 0) {
                            $alert('No results found');
                            commit('setStatus', 'selected');
                            commit('setSelectedProduct', '');
                            commit('setNewProducts', 'all');
                            const prodType = cloneDeep(state.productTypes);
                            prodType.forEach((type) => {
                                state.searchProductType.forEach((val) => {
                                    if(type.symbol === val){
                                        type.selected = !type.selected;
                                    }
                                })
                            });
                            const regns = cloneDeep(state.regions);
                            regns.forEach((reg) => {
                                state.selectedRegion.forEach((val) => {
                                    if(reg.value === val){
                                        reg.selected = !reg.selected;
                                    }
                                });
                            });
                            commit('setProdTypes', prodType);
                            commit('setSearchProductType', []);
                            commit('setRegn', regns);
                            commit('setSelectedRegion', []);
                            commit('setPageNumber', 1);
                            commit('setDefaultRegion', 'na');
                        } else {
                            console.debug(response);
                            // let pageCount = response.map(res => res['pageCount']);
                            let pageCount = response.productCount;
                            if(state.typesList.length === 0){
                                let prodTypes = [];
                                let uniqueTypes = [];
                                let pdt;
                                
                                response.productTypeCount.forEach(product => {
                                    const pdt = state.productTypes.find(type => type.symbol === product.productType);
                                    prodTypes.push({name: pdt.name, symbol: pdt.symbol, totalCount: product.totalCount});
                                })

                                // Sort in product types in a particular order
                                prodTypes.sort((a, b) => getters.preferredProductTypeOrder[a.symbol] - getters.preferredProductTypeOrder[b.symbol]);
                                
                                commit('setTypesList', prodTypes);
                                commit('setSelectedProductType', 'all');
                            }
                            let products = state.restrictedProducts.map(product => product.symbol);

                            // Sort response based on country
                            response.products.sort((a,b) => {
                                if(a.country != null){
                                    a.country.localeCompare(b.country)
                                }
                            });

                            // Filter results based on restriction for various products types
                            let results = [];
                            let existingConids = [];
                            let existingUnderConids = [];

                            for(let i=0; i<response.products.length; i++){
                                if(getters.selectedDomain === 'jp'){
                                    if(response.products[i].type === 'FUT'){
                                        if(!products.includes(response.products[i].symbol)) {
                                            if(response.products[i].country === 'JP' && response.products[i].exchangeId === 'SGXCME') {
                                                continue;
                                            } else {
                                                results.push(response.products[i]);
                                            }
                                        }
                                    } else {
                                        results.push(response.products[i]);
                                    }
                                } else if(response.products[i].type === 'CRYPTO') {
                                    if(state.allowedCryptoProducts.includes(response.products[i].symbol)){
                                        results.push(response.products[i]);
                                    }
                                } else if(response.products[i].type === 'WAR' || response.products[i].type === 'FOP' || response.products[i].type === 'OPT'){
                                    // Logic to group warrant results based on conid, local symbol and country. Also find exchange with is_prime_exch_id = 'T' and add an asterisk to it
                                    
                                    if(results.length === 0){
                                        existingUnderConids.push(response.products[i].underConid);
                                        results.push(response.products[i]);
                                    } else {
                                        if(existingUnderConids.includes(response.products[i].underConid)){
                                            let idx = results.findIndex(res => res.underConid === response.products[i].underConid)
                                            if(!results[idx].localSymbol.split(",").includes(response.products[i].localSymbol)){
                                                results[idx].localSymbol = results[idx].localSymbol.concat(",", response.products[i].localSymbol);
                                            }
                                            if(!results[idx].country.split(",").includes(response.products[i].country)){
                                                results[idx].country = results[idx].country.concat(",", response.products[i].country);
                                            }
                                            if(!results[idx].exchangeId.split(",").includes(response.products[i].exchangeId)){
                                                results[idx].exchangeId = results[idx].exchangeId.concat(",", response.products[i].exchangeId);
                                            }
                                        } else {
                                            existingUnderConids.push(response.products[i].underConid);
                                            results.push(response.products[i]);
                                        }
                                    }
                                } else {
                                    if(results.length === 0){
                                        if(response.products[i].conid != null){
                                            existingConids.push(response.products[i].conid);
                                        } else {
                                            existingConids.push(response.products[i].underConid);
                                        }
                                        // existingConids.push(response.products[i].conid);
                                        if(response.products[i].isPrimeExchId === 'T'){
                                            response.products[i].exchangeId = response.products[i].exchangeId.concat("*");
                                        }
                                        results.push(response.products[i]);
                                    } else {
                                        if(existingConids.includes(response.products[i].conid) || existingConids.includes(response.products[i].underConid)){
                                            let idx;
                                            if(response.products[i].conid != null){
                                                idx = results.findIndex(res => res.conid === response.products[i].conid);
                                            } else {
                                                idx = results.findIndex(res => res.underConid === response.products[i].underConid);
                                            }

                                            // let idx = results.findIndex(res => res.conid === response.products[i].conid);
                                            if(!results[idx].exchangeId.split(",").includes(response.products[i].exchangeId)){
                                                if(response.products[i].isPrimeExchId === 'T') {
                                                    results[idx].exchangeId = response.products[i].exchangeId.concat("*,", results[idx].exchangeId);
                                                } else {
                                                    results[idx].exchangeId = results[idx].exchangeId.concat(",", response.products[i].exchangeId);
                                                }
                                            }
                                        } else {
                                            if(response.products[i].conid != null){
                                                existingConids.push(response.products[i].conid);
                                            } else {
                                                existingConids.push(response.products[i].underConid);
                                            }

                                            // existingConids.push(response.products[i].conid);
                                            if(response.products[i].isPrimeExchId === 'T'){
                                                response.products[i].exchangeId = response.products[i].exchangeId.concat("*");
                                            }
                                            results.push(response.products[i]);
                                        }
                                    }
                                }
                            }
                            results.sort((a,b) => a.symbol.localeCompare(b.symbol));
                            
                            if(results.length === 0){
                                $alert("No results found");
                                dispatch('reset');
                            } else {
                                commit('setProducts', results);
                                commit('setTotalPages', pageCount);
                                commit('setProductResults', results);
                                commit('setSearchResults', results);
                                const warning = state.searchResults.find(product => product.type === 'OPT' || product.type === 'FUT' || product.type === 'FOP');
                                if(warning) {
                                    commit('setShowWarning', true);
                                } else {
                                    commit('setShowWarning', false);
                                }
                                commit('setStatus', 'filterResults');
                                if(state.searchResults.length < 100){
                                    commit('setResultStatus', false);
                                } else {
                                    commit('setResultStatus', true);
                                }
                                commit('setApiStatus', 'results');
                            }
                            commit('setPreviousSort', state.currentSort);
                        }
                    })
                    .catch(error => {
                        $alert('No results found');
                        commit('setStatus', 'selected');
                        commit('setSelectedProduct', '');
                        commit('setNewProducts', 'all');
                        const prodType = cloneDeep(state.productTypes);
                        prodType.forEach((type) => {
                            state.searchProductType.forEach((val) => {
                                if(type.symbol === val){
                                    type.selected = !type.selected;
                                }
                            })
                        });
                        const regns = cloneDeep(state.regions);
                        regns.forEach((reg) => {
                            state.selectedRegion.forEach((val) => {
                                if(reg.value === val){
                                    reg.selected = !reg.selected;
                                }
                            });
                        });
                        commit('setProdTypes', prodType);
                        commit('setSearchProductType', []);
                        commit('setRegn', regns);
                        commit('setSelectedRegion', []);
                        commit('setPageNumber', 1);
                        commit('setDefaultRegion', 'na');
                        console.error(error);
                    });
            })
        },
    },
    getters: {
        selectedProductTypes(state) {
            return state.productTypes.filter(item => item.selected).map(item => item.name);
        },
        selectedRegions(state) {
            return state.regions.filter(item => item.selected).map(region => region.name);
        },
        selectedDomain(state) {
            let domainValue = state.hostName.split('.').length-1;
            return state.hostName.split('.')[domainValue];
        },
        selectedSubDomain(state) {
            return state.hostName.split('.').shift();
        },
        selectedTrackingUrl(state, getters) {
            let url = state.signUpTrackingURLs.filter(url => url.domain === getters.selectedDomain).map(url => url.url);
            return url[0];
        },
        preferredProductTypeOrder(state) {
            const productTypeOrder = state.productTypes.reduce((obj, type, index) => {
                return {
                    ...obj,
                    [type.symbol]: index,
                };
            }, {});
            return productTypeOrder;
        },
    },
})